import type { ApiResponse } from '@bitstopco/bitstop-theme';

import api from '@/store/api';
import { athena } from '@/store/api/instances';

import type { NodeWalletInfo } from '@/types';

/**
 * Wallet RTK-Query API
 * For more information about RTK-Query see
 * * https://redux-toolkit.js.org/rtk-query/overview
 * ! This API instance is used for the operator's node wallet (formerly served by Ergot)
 * ! This information is used in the Header
 */
export const commonWalletApi = api.injectEndpoints({
  endpoints: (build) => ({
    getNodeWalletInfo: build.query<NodeWalletInfo, void>({
      query: () => athena({ url: 'v2/wallet/info' }),
      transformResponse: (response: ApiResponse<NodeWalletInfo>) => response?.data || {},
      providesTags: ['NodeWalletInfo'],
    }),
  }),
});

export const { useGetNodeWalletInfoQuery } = commonWalletApi;

export const {
  endpoints: { getNodeWalletInfo },
} = commonWalletApi;
